import { dashboardTiles } from "../pages/Dashboard/Dashboard.constants";
import { FeatureFlagKey } from "../types/featureFlags.types";

export const PAGE_PERMISSIONS: Record<string, string[]> = Object.fromEntries(
  dashboardTiles.map((tile) => [tile.id, tile.allowedGroups]),
);

// Lets ProtectedRoute block direct navigation to a page whose tile is feature-flagged off -
// otherwise disabling a tile would only hide it from the dashboard/nav, not the route itself.
export const PAGE_FEATURE_FLAGS: Record<string, FeatureFlagKey | undefined> = Object.fromEntries(
  dashboardTiles.map((tile) => [tile.id, tile.featureFlag]),
);
